<template>
    <div class="container" ref="container">
        <!-- Left Box Slot -->
        <div ref="leftBox" class="left-box" :style="{'flex': leftFlex}">
            <slot name="leftBox" :data="parent"></slot>
        </div>

        <svg ref="lineSvg" class="svg-container" :style="{'flex': svgFlex}">
            <!-- 画的线将会动态生成 -->
            <!-- 光点将会沿着这些线进行动画 -->
            <g v-for="(line, index) in lines" :key="index">
                <g v-for="(line, index) in lines" :key="index">
                <!-- 动态绘制线条 -->
                <line
                    :x1="line.x1"
                    :y1="line.y1"
                    :x2="line.x2"
                    :y2="line.y2"
                    stroke="#6950a1"
                    stroke-width="2"
                    :class="{ 'line-animation': isAnimating }"
                />
                <text
                    :x="(line.x1 + line.x2) / 2"
                    :y="(line.y1 + line.y2) / 2 - 10"
                    fill="black"
                    font-size="14"
                    text-anchor="middle">
                    {{ line.text }}
                </text>
            </g>
            </g>
        </svg>

        <!-- Right Box Slot (Loop Animation) -->
        <div ref="rightBoxContainer" class="right-box-container" :class="{ 'loop-animation': isAnimating }" :style="{'flex': rightFlex}">
            <div v-for="(item, index) in children" :key="index" class="right-box">
                <slot name="rightBox" :data="item" :index="index"></slot>
                <el-button type="text" style="margin-left: 10px;color: #f56c6c;" icon="el-icon-delete"
                    @click="deleteElement(index)">
                </el-button>
            </div>
        </div>

        <div class="add-post">
            <el-button type="primary" size="small" @click="addElement">{{ addButtonName }}</el-button>
        </div>
    </div>

</template>

<script>
export default {
  name: 'DynamicFormWithSlots',
  props: {
    // 父元素
    parent: {
      type: Object,
      default: null
    },
    // 子元素
    children: {
      type: Array,
      default: []
    },
    // 添加元素
    addElement: {
      type: Function,
      default: null
    },
    // 添加按钮名称
    addButtonName: {
      type: String,
      default: '添加元素'
    },
    // 删除元素
    deleteElement: {
      type: Function,
      default: null
    },
    lineText: {
      type: String,
      default: '岗位'
    },
    leftFlex: {
      type: Number,
      default: 1
    },
    rightFlex: {
      type: Number,
      default: 5
    },
    svgFlex: {
      type: Number,
      default: 1
    }
  },
  watch: {
    children: {
      handler (newVal) {
        this.$nextTick(this.updateLines)
      },
      deep: true
    }
  },
  data () {
    return {
      lines: [],
      isAnimating: true

    }
  },
  mounted () {
    this.$nextTick(this.updateLines)
    window.addEventListener('resize', this.updateLines)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateLines)
  },
  methods: {
    updateLines () {
      const container = this.$refs.container.getBoundingClientRect()
      const leftBox = this.$refs.leftBox.getBoundingClientRect()
      const rightBoxes = this.$refs.rightBoxContainer.children
      const svg = this.$refs.lineSvg

      this.svgWidth = svg.width
      // this.svgHeight = container.height;
      this.svgHeight = this.$refs.rightBoxContainer.getBoundingClientRect().height
      if (this.svgHeight > 0) {
        svg.setAttribute('height', this.svgHeight)
      }
      svg.innerHTML = ''

      const svgCTM = svg.getScreenCTM()

      function toSvgCoordinates (rect) {
        const svgX = (rect.left - svgCTM.e) / svgCTM.a
        const svgY = (rect.top - svgCTM.f) / svgCTM.d
        return { x: svgX, y: svgY }
      }

      const svgBox = svg.getBoundingClientRect()
      const svgBoxCoords = toSvgCoordinates(svgBox)
      // const leftX = leftBoxCoords.x + leftBox.width;
      const leftX = svgBoxCoords.x
      const leftY = svgBoxCoords.y + svgBox.height / 2

      const svgCenterX = svg.width.baseVal.value / 2
      const svgCenterY = svg.height.baseVal.value / 2

      const leftHorizontalLine = document.createElementNS('http://www.w3.org/2000/svg', 'line')
      leftHorizontalLine.setAttribute('x1', leftX)
      leftHorizontalLine.setAttribute('y1', leftY)
      leftHorizontalLine.setAttribute('x2', svgCenterX)
      leftHorizontalLine.setAttribute('y2', leftY)
      leftHorizontalLine.setAttribute('stroke', '#6950a1')
      leftHorizontalLine.setAttribute('stroke-width', '2')
      this.lines = []
      this.$nextTick(() => {
        this.lines.push({ x1: leftX, y1: leftY, x2: svgCenterX, y2: leftY, text: this.lineText })
      })
      if (this.children.length === 0) {
        this.isAnimating = true
        return
      } else {
        this.isAnimating = false
        svg.appendChild(leftHorizontalLine)
      }
      for (let i = 0; i < rightBoxes.length; i++) {
        const rightBoxRect = rightBoxes[i].getBoundingClientRect()
        const rightBoxCoords = toSvgCoordinates(rightBoxRect)
        const rightX = rightBoxCoords.x
        const rightY = rightBoxCoords.y + rightBoxRect.height / 2

        const verticalLine = document.createElementNS('http://www.w3.org/2000/svg', 'line')
        verticalLine.setAttribute('x1', svgCenterX)
        verticalLine.setAttribute('y1', svgCenterY)
        verticalLine.setAttribute('x2', svgCenterX)
        verticalLine.setAttribute('y2', rightY)
        verticalLine.setAttribute('stroke', '#6950a1')
        verticalLine.setAttribute('stroke-width', '2')
        svg.appendChild(verticalLine)
        const horizontalLine = document.createElementNS('http://www.w3.org/2000/svg', 'line')
        horizontalLine.setAttribute('x1', svgCenterX)
        horizontalLine.setAttribute('y1', rightY)
        horizontalLine.setAttribute('x2', rightX)
        horizontalLine.setAttribute('y2', rightY)
        horizontalLine.setAttribute('stroke', '#6950a1')
        horizontalLine.setAttribute('stroke-width', '2')
        svg.appendChild(horizontalLine)
      }
    }
  }
}
</script>

<style scoped>
.footer {
    text-align: center;
    margin-top: 20px;
}

.container {
    display: flex;
    position: relative;
    align-items: center;
    margin: 50px;
    height: auto; /* 自动适应内容高度 */
    flex-shrink: 1; /* 允许容器随着内容减少而缩小 */
}

.left-box {
    flex: 1;
    border-radius: 5px;
    padding: 20px;
    background-color: #d1dce2;
    display: flex;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    justify-content: center;
    align-items: center;
}

.right-box-container {
    flex: 5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto; /* 自动适应内容高度 */
    flex-shrink: 1; /* 允许容器随着内容减少而缩小 */
}

.right-box {
    width: 100%;
    background-color: #d1dce2;
    display: flex;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    justify-content: center;
    align-items: center;
    padding: 20px;
    border-radius: 5px;
    margin: 10px;
    height: auto; /* 自动适应内容高度 */
    flex-shrink: 1; /* 允许容器随着内容减少而缩小 */
}

svg {
    flex: 1;
    height: 100%;
    z-index: 99;
    pointer-events: none;
}

.add-post {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loop-animation {
    animation: boxLoop 3s infinite;
}

@keyframes boxLoop {
}
/* 动态绘制线条的动画效果 */
.line-animation {
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: dash 4s ease-in-out infinite;
}

@keyframes dash {
    to {
        stroke-dashoffset: 0;
    }
}
</style>
